import { z } from "zod";

export const stationSchema = z.object({
  name: z.string().min(3, "Name must be at least 3 characters"),
  connectorId: z.string().min(1, "Connector ID is required"),
  paymentId: z.string().min(1, "Payment ID is required"),
  pricePerKWh: z.string().min(1, "Price per kWh is required"),
  currency: z.enum(["USD", "EUR"], {
    required_error: "Please select a currency",
  }),
});

export type StationFormData = z.infer<typeof stationSchema>;
